import {useMemo, useState} from 'react';
import {useNavigate} from "react-router-dom";

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import {alpha} from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import {logout} from "@/api/auth";
import {
  LS_AUTHINFO,
  getLocalStorage,
  clearAuthStorage,
} from "@/utils/storage";
import {ROUTE_LOGIN, STR_LOGOUT_ERROR, ROUTE_DASHBOARD} from "@/utils/context/constants";
import Iconify from "@/components/iconify";

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
    route: ROUTE_DASHBOARD
  }
];

// ----------------------------------------------------------------------

const getAvatarRandom = () => {
  const rand = Math.round(Math.random() * (25 - 1) + 1);
  return `/assets/images/avatars/avatar_${rand}.jpg`;
}

export default function AccountPopover() {
  const navigate = useNavigate();
  const authInfo = JSON.parse(getLocalStorage(LS_AUTHINFO));
  const avatarImg = useMemo(() => getAvatarRandom(), [authInfo?.email]);

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const goToRoute = (route) => {
    setOpen(null);
    navigate(route);
  };

  const handleLogout = () => {
    setOpen(null);
    logout().then((data) => {
      if (!!data && !!data?.status && data?.status === 'success') {
        clearAuthStorage();
        !!navigate && navigate(ROUTE_LOGIN);
      } else {
        // TODO messaggio di errore logout
        console.warn(STR_LOGOUT_ERROR);
      }
    });
    return true;
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={avatarImg}
          alt={authInfo?.user}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {authInfo?.user.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 200,
          },
        }}
      >
        <Box sx={{my: 1.5, px: 2}}>
          <Typography variant="subtitle2" noWrap>
            {authInfo?.user  || '-'}
          </Typography>
          <Typography variant="body2" sx={{color: 'text.secondary'}} noWrap>
            {authInfo?.email || '-'}
          </Typography>
        </Box>

        <Divider sx={{borderStyle: 'dashed'}}/>

        {MENU_OPTIONS.map((option) => (
          <MenuItem key={option.label} onClick={() => goToRoute(option.route)}>
            <Iconify icon={option.icon}></Iconify>
            {option.label}
          </MenuItem>
        ))}

        <Divider sx={{borderStyle: 'dashed', m: 0}}/>

        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={handleLogout}
          sx={{typography: 'body2', color: 'error.main', py: 1.5}}
        >
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
